import { useState } from "react";
import { FormControl,InputLabel,Select,MenuItem } from "@mui/material";
import { UndoRounded } from "@mui/icons-material";


/**
 * 
 * @param {props} headerText - text displayed in the h5 
 * @param {props} selectText - text displayed in label of Select
 * @param {props} selectedCompany - stateful selected company
 * @param {props} setSelectedCompany - set of stateful
 * @param {props} allCompanies - passed in set of companies for select
 * @param {props} showAllCompanies - display all/subset companies
 * @param {props} onChange - allows you to hook up to a function call in the parent, leave off if not using
 * @returns 
 */
function CompanySelect(props)
{
    //Selected Company in Select form control
    //const [selectedCompany,setSelectedCompany] = useState(0);

    const handleChange = (e)=>
    {
        if(props.setSelectedCompany)
        {
            props.setSelectedCompany(e.target.value);
        }
        if(props.onChange)
        {
            props.onChange(e);
        }
    }

    if(props.allCompanies!==null && props.allCompanies!==undefined && props.allCompanies.length>0)
    {
    return(
    <>
        <h5>{props.headerText}</h5>
            
                    <FormControl className="formControl">
                        <InputLabel id="demo-simple-select-label">{props.selectText}</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={props.selectText}
                            onChange={handleChange}
                            value={
                                (props.selectedCompany===undefined||
                                props.selectedCompany===null||
                                props.allCompanies.length===0)?'0':
                                props.selectedCompany
                            }
                        >
                            <MenuItem value='0' key='0' disabled>Select Company</MenuItem>
                            
                            {
                                props.allCompanies.map((ele) => {
                                    if(props.showAllCompanies)
                                    {
                                        return <MenuItem value={ele.companyId} key={ele.companyId}>{ele.companyName}</MenuItem>
                                    }else{
                                    if (ele.peerGroupId === null)
                                        return <MenuItem value={ele.companyId} key={ele.companyId}>{ele.companyName}</MenuItem>
                                    }
                                })
                            }

                        </Select>
                    </FormControl>
    </>
    );
    }
    else{
        return(
            <></>
        )
    }

}

export default CompanySelect;